<div class="layout-column layout-align-center-center">
  <img class="flex image-size" [src]="src">
  <span *ngIf="!!text" class="br-head-2 font-weight-600 color-gray-102">{{text | translate}}</span>
  <span *ngIf="!!description"
        class="text-center br-body-2 font-weight-400 color-gray-102">{{description | translate}}
  </span>

  <div *ngIf="action" class="padding-top-10 layout-row layout-align-center-center">
    <bringoz-button [theme]="'primary'"
                    [type]="'raised'"
                    (onClick)="actionEvent.emit()">
      <span class="br-body-2">{{action | translate}}</span>
    </bringoz-button>
  </div>
</div>
